import React from "react";
import { useDispatch } from "react-redux";

import { closeAlert } from "../../../../redux/actions/alert/alertActions";

import { StyledDeleteUserComment } from "./styledUserCommentComponent";

const DeleteUserCommentComponent = ({ handleDeleteComment, commentID }) => {
  const dispatch = useDispatch();
  return (
    <StyledDeleteUserComment className="text-center">
      <p>آیا می‌خواهید این نظر حذف شود؟</p>
      <div className="d-flex">
        <button
          onClick={() => handleDeleteComment(commentID)}
          className="accept border-0 mx-3"
        >
          بله
        </button>
        <button
          onClick={() => dispatch(closeAlert())}
          className="decline border-0 mx-3"
        >
          خیر
        </button>
      </div>
    </StyledDeleteUserComment>
  );
};

export default DeleteUserCommentComponent;
